import FormWithProvider from 'components/forms/form/Form';
import FormFieldset from 'components/forms/form/FormFieldset';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import { Modal, ModalFooter } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import EmailSearchField from '../EmailSearchField';
import LoginasModalSubmitButton from './LoginasModalSubmitButton';

export const loginasModalId = 'loginas-modal';

const schema = () => ({
  email: Yup.array().of(Yup.string().required()).required(),
});

const LoginasModal = ({ onSubmit }: { onSubmit: (data: any) => void }) => {
  const { t } = useTranslation();

  return (
    <FormWithProvider
      horizontal
      schema={schema()}
      onSubmit={onSubmit}
      data-testid="loginas-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('common.loginas.logInAsAnotherUser')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormFieldset>
          <EmailSearchField
            name="email"
            label={t('common.email')}
            align="left"
            colSmLabel={2}
            colSmInput={10}
            data-testid="loginas-email-search-field"
          />
        </FormFieldset>
      </Modal.Body>
      <ModalFooter>
        <ModalFormCancelButton />
        <LoginasModalSubmitButton />
      </ModalFooter>
    </FormWithProvider>
  );
};

export default LoginasModal;
